/**
 * Curated list of common IANA timezones for the distributor timezone picker.
 *
 * Card: https://trello.com/c/sv7UGPvt
 *
 * Two surfaces consume this list, and share it intentionally so the
 * SA edit page (`/admin/distributors/:id/edit`) and the tenant
 * Profile "Locale & Preferences" section never drift apart:
 *   - frontend/src/pages/superadmin/DistributorEdit.vue
 *   - frontend/src/pages/distributor/account/DistributorProfile.vue
 *
 * Each entry is `{ value, label }`:
 *   - `value` is the canonical IANA name (stored as-is in
 *     `distributors.timezone`; consumed by Python's `zoneinfo.ZoneInfo`
 *     on the backend's `_today_range(distributor)` helper).
 *   - `label` is human-friendly text for the v-select dropdown. NOT
 *     stored anywhere; purely UI-facing.
 *
 * The list is intentionally short (~12 zones) so the picker stays
 * scannable. A future iteration could broaden via grouping or
 * autocomplete; today's tenants are all US-centric per the GTM plan,
 * with a few EU / APAC entries for headquarters edge cases. UTC is
 * the explicit fallback so a tenant can opt into the legacy
 * pre-PR-E behaviour.
 *
 * ASCII-only labels.
 */

export const COMMON_TIMEZONES = Object.freeze([
    { value: "America/New_York", label: "Eastern (US/Canada)" },
    { value: "America/Chicago", label: "Central (US/Canada)" },
    { value: "America/Denver", label: "Mountain (US/Canada)" },
    { value: "America/Los_Angeles", label: "Pacific (US/Canada)" },
    { value: "America/Anchorage", label: "Alaska" },
    { value: "Pacific/Honolulu", label: "Hawaii" },
    { value: "Europe/London", label: "UK" },
    { value: "Europe/Paris", label: "Central Europe (Paris)" },
    { value: "Europe/Berlin", label: "Central Europe (Berlin)" },
    { value: "Asia/Tokyo", label: "Japan" },
    { value: "Australia/Sydney", label: "Australia" },
    { value: "UTC", label: "UTC" },
]);
